<template>
	<div>
      <swiper :slides-per-view="1" :space-between="15" loop>
      <swiper-slide v-for="item in items" :key="item.title">
		<v-flex class="col-12">
		<v-card class="content">
			<v-card-title style="padding: 5px !important;"><div class="custom-card-title">{{item.title}}</div></v-card-title>
			<v-card-text style="margin: 10px auto;">
				<v-layout row>
					<v-flex xs12 md3 class="custom-card-key">ชื่อ</v-flex>
					<v-flex xs12 md9 class="custom-card-value">{{item.firstname}}</v-flex>
				</v-layout>
				<v-layout row>
					<v-flex xs12 md3 class="custom-card-key">วันที่ยื่นคำขอ</v-flex>
					<v-flex xs12 md9 class="custom-card-value">{{item.reqDate}}</v-flex>
				</v-layout>
				<v-layout row>
					<v-flex xs12 md3 class="custom-card-key">สนท.ที่ยื่นคำขอ</v-flex>
					<v-flex xs12 md9 class="custom-card-value">{{item.reqRcode}}</v-flex>
				</v-layout>
				<v-layout row>
					<v-flex xs12 md3 class="custom-card-key">สถานะคำขอ</v-flex>
					<v-flex xs12 md9 class="custom-card-value">{{item.status.desc}}</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-layout row>
					<v-flex xs12>
						<v-container fluid style="background-color: whitesmoke;padding-left: 0px;">
							<v-timeline dense>
								<v-timeline-item v-for="statusList in item.statusList" :key="statusList.code" :color="statusList.code == item.status.code ?color.active : color.disable">
									<div class="custom-step-value" v-if="overWidth(item,statusList.code)">{{statusList.desc}}</div>
									<div class="custom-step-value" style=" font-size: 1.0rem;" v-else>{{statusList.desc}}</div>
								</v-timeline-item>
								<div v-if="item.flag==3">
									<v-timeline-item 
										v-if="checkPDF(item.status.code)"
										@click.native.stop="openPDF(item.pdf,item.title)" 
										large 
										icon="mdi-cloud-download" 
										:color="color.active"
										:style="cursor.active">
										<div class="custom-step-value">แสกนเอกสารการอนุญาตให้สถานะฯ</div>
									</v-timeline-item>
									<v-timeline-item 
										v-else
										large 
										icon="mdi-cloud-download" 
										:color="color.disable"
										:style="cursor.disable">
										<div class="custom-step-value">แสกนเอกสารการอนุญาตให้สถานะฯ</div>
									</v-timeline-item>
								</div>
							</v-timeline>
						</v-container>
					</v-flex>
				</v-layout>
			</v-card-actions>
		</v-card>
		</v-flex>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper-vue2'
import 'swiper/swiper-bundle.css'

export default {
	name: "content-mobile",
	components: {
		Swiper,
		SwiperSlide,
	},
	props: {
		items: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			color:{
				active:"green darken-1",
				disable:"blue-grey lighten-1"
			},
			cursor:{
				active:"cursor: pointer;",
				disable:"cursor: no-drop;"
			},
		}
	},
	methods: {
		overWidth(item,code){
			console.log(item)
			if(item.flag != 3) return true;
			if(![11,12].includes(code)) return true;
			const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
			if(width>=500) return true;
			return false;
		},
		checkPDF(status){
			if([35].includes(status)) return true;
			return false
		},
		openPDF(base64,pdf) {
			const tempLink = document.createElement('a');
			tempLink.href = `data:image/jpeg;base64,${base64}`;
			tempLink.setAttribute('download', `${pdf}.jpg`);
			tempLink.click();
		},
	}
};
</script>
<style scoped>
.content {
	background: #fff;
    /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px !important; */
    border-radius: 5px;
    border: 0.063rem solid #ddd;
    padding: 1.25rem;
  }
  .custom-card-title{
    color: #011265 !important;
    caret-color: #011265 !important;
    font-size: 1.55rem;
    font-weight: 700 !important;
    padding: 5px !important;
  }
  .custom-card-key{
	color: black;
    font-size: 1.4rem;
    font-weight: 500 !important;
    padding: 3px !important;
	margin: 2px auto !important;
  }
  .custom-card-value{
	color: black;
    font-size: 1.4rem;
    font-weight: 700 !important;
    padding: 3px !important;
	margin: 2px auto !important;
  }

  .custom-step-value{
	color: black;
    font-size: 1.25rem;
    font-weight: 700 !important;
	margin-top: 1.25vh;
  }
</style>
